if (!customElements.get("product-addons")) {
  customElements.define(
    "product-addons",
    class ProductAddons extends HTMLElement {
      constructor() {
        super();
        this.form = this.dataset.form;
        this.textarea = this.querySelector(
          'textarea[name="properties[Dedication]"]'
        );
        this.enInput = this.querySelector(
          'input[name="properties[English/French Name]"]'
        );
        this.arInput = this.querySelector(
          'input[name="properties[Arabic Name]"]'
        );
        this.setDedicationArray = Array.from(
          this.querySelectorAll(".setDedication")
        );
        this.toggleProductsArray = Array.from(
          this.querySelectorAll(".toggleProducts")
        );

        this.CheckboxtoggleInputArray = Array.from(
          this.querySelectorAll(".gift-wrapping")
        );

        this.setDedicationArray.forEach((radio) =>
          radio.addEventListener("click", this.setDedication.bind(this))
        );
        this.toggleProductsArray.forEach((products) =>
          products.addEventListener("click", this.toggleProducts.bind(this))
        );

        this.CheckboxtoggleInputArray.forEach((gift) =>
          gift.addEventListener("click", this.toggleGift.bind(this))
        );

        this.initAddon();
      }

      setDedication(event) {
        const currentLang = this.querySelector(
          'input[name="properties[Second Language]"]:checked'
        ).value;
        const enInput = this.enInput.value;
        const arInput = this.arInput.value;
        const currentGender = this.querySelector(
          'input[name="properties[Gender]"]:checked'
        ).value;

        this.textarea.value = this.dedicationNote(
          currentLang,
          currentGender,
          enInput,
          arInput
        );
      }

      toggleProducts(event) {
        const parentElement = event.target.closest(".c-form__fieldset");

        const hardElem = this.querySelector(`#hard_cover-${this.form}`);
        const softElem = this.querySelector(`#soft_cover-${this.form}`);
        const hardElemInputs = hardElem.querySelectorAll(
          'input[type="hidden"]'
        );
        const softElemInputs = softElem.querySelectorAll(
          'input[type="hidden"]'
        );

        if (event.target.value === "Hard Cover") {
          softElemInputs.forEach((input) =>
            input.setAttribute("disabled", "disabled")
          );
          hardElemInputs.forEach((input) => input.removeAttribute("disabled"));
        } else if (event.target.value === "Soft Cover") {
          hardElemInputs.forEach((input) =>
            input.setAttribute("disabled", "disabled")
          );
          softElemInputs.forEach((input) => input.removeAttribute("disabled"));
        }
      }

      toggleGift(event) {
        const parentElement = event.target.closest(".c-form__fieldset");
        const inputElements = parentElement.querySelectorAll(
          'input[type="hidden"]'
        );

        inputElements.forEach((input) => {
          if (event.target.checked) {
            input.removeAttribute("disabled");
          } else {
            input.setAttribute("disabled", "disabled");
          }
        });
      }

      dedicationNote(
        currentLang = "",
        currentGender = "",
        enInput = "",
        arInput = ""
      ) {
        let dedicationText = "";
        currentLang = currentLang.trim();
        currentGender = currentGender.trim();

        switch (currentLang) {
          case "English":
            this.textarea.style.direction = "ltr";
            this.enInput
              .closest(".c-form__fieldset")
              .classList.remove("hidden");
            this.enInput.required = true;
            this.enInput.removeAttribute("disabled");
            dedicationText = `Dear ${enInput},\nWe hope you enjoy this magical trip to your country. May all your days be filled with exciting adventures and wonderful discoveries. Wherever life takes you, never forget your roots.`;
            break;
          case "Spoken Arabic":
            this.textarea.style.direction = "rtl";
            this.enInput.closest(".c-form__fieldset").classList.add("hidden");
            this.enInput.required = false;
            this.enInput.setAttribute("disabled", "disabled");
            dedicationText =
              currentGender === "Girl"
                ? `عزيزتي ${arInput},\nنأمل أن تستمتعي بهذه الرحلة السحرية إلى بلدك،\nكما نتمنى لك أياماً مليئة بالمغامرات الشيّقة والجميلة، والاستكشافات الثريّة والرائعة!\nاحرصي ألا تنسي جذورك أبداً، أينما أخذتك الحياة!\nمع كل الحب.\n`
                : `عزيزي ${arInput},\nنأمل أن تستمتع بهذه الرحلة السحرية إلى بلدك،\nكما نتمنى لك أياماً مليئة بالمغامرات الشيّقة والجميلة، والاستكشافات الثريّة والرائعة!\nاحرص ألا تنسى جذورك أبداً، أينما أخذتك الحياة!\nمع كل الحب.\n`;
            break;
          case "French":
            this.textarea.style.direction = "ltr";
            this.enInput
              .closest(".c-form__fieldset")
              .classList.remove("hidden");
            this.enInput.required = true;
            this.enInput.removeAttribute("disabled");
            // dedicationText = `${
            //   currentGender === "Girl" ? "Chère" : "Cher"
            // } ${enInput},\nNous espérons que ce voyage magique te plaira. Que ta vie soit remplie d’aventures remarquables! Où que tu ailles, quoi que tu fasses, n’oublie jamais tes origines! Avec toute notre affection.`;
            dedicationText =
              currentGender === "Girl"
                ? `Chère ${enInput},\nNous espérons que ce voyage magique te plaira. Que ta vie soit remplie d’aventures remarquables! Où que tu ailles, quoi que tu fasses, n’oublie jamais tes origines! Avec toute notre affection.`
                : `Cher ${enInput},\nNous espérons que ce voyage magique te plaira. Que ta vie soit remplie d’aventures remarquables! Où que tu ailles, quoi que tu fasses, n’oublie jamais tes origines! Avec toute notre affection.`;
            break;
          default:
            this.textarea.style.direction = "ltr";
            this.enInput
              .closest(".c-form__fieldset")
              .classList.remove("hidden");
            this.enInput.required = true;
            this.enInput.removeAttribute("disabled");
            dedicationText = `Dear,\nWe hope you enjoy this magical trip to your country. May all your days be filled with exciting adventures and wonderful discoveries. Wherever life takes you, never forget your roots.`;
            break;
        }

        return dedicationText;
      }

      initAddon() {
        // const script = document.createElement("script");
        // script.src = "//api.yamli.com/js/yamli_api.js";
        // // Find the target div
        // var div = document.getElementById("yampliapi");
        // // Append the script to the div
        // div.appendChild(script);
        // YAMLI CODE START

        // if (
        //   typeof Yamli == "object" &&
        //   Yamli.init({ uiLanguage: "en", startMode: "onOrUserDefault" })
        // ) {
        //   setTimeout(function () {
        //     console.log(`yamli_true`, Yamli);
        //     Yamli.yamlifyClass("yamli_true", { settingsPlacement: "inside" });
        //     Yamli.init();
        //   }, 2000);
        //  }
        //YAMLI CODE END

        //  $('input[name="properties[Second Language]"]').click(function(){
        //    var radioSelect = $(this).val();
        //    console.log(radioSelect);
        // if(radioSelect == "Spoken Arabic")
        //  {
        //     if (this.arInput) {
        //    this.arInput.addEventListener("input", () => {
        //      // console.log("input",this.arInput);
        //      const currentLang = this.querySelector(
        //        'input[name="properties[Second Language]"]:checked'
        //      ).value;
        //      const currentGender = this.querySelector(
        //        'input[name="properties[Gender]"]:checked'
        //      ).value;
        //      const arInput = this.arInput.value;

        //      this.textarea.value = this.dedicationNote(
        //        currentLang.trim(),
        //        currentGender.trim(),
        //        arInput,
        //        this.arInput.value
        //      );
        //    });
        //     }
        //  }
        //  else
        // {
        //    if (this.enInput) {
        //    this.enInput.addEventListener("input", () => {
        //      const currentLang = this.querySelector(
        //        'input[name="properties[Second Language]"]:checked'
        //      ).value;
        //      const currentGender = this.querySelector(
        //        'input[name="properties[Gender]"]:checked'
        //      ).value;
        //      const enInput = this.enInput.value;
        //      this.textarea.value = this.dedicationNote(
        //        currentLang.trim(),
        //        currentGender.trim(),
        //        enInput,
        //        this.enInput.value
        //      );
        //    });
        //  }
        // }
        // });
        console.log(this.arInput);
        if (this.arInput) {
          this.arInput.addEventListener("input", () => {
            // console.log("input",this.arInput);
            const currentLang = this.querySelector(
              'input[name="properties[Second Language]"]:checked'
            ).value;
            const currentGender = this.querySelector(
              'input[name="properties[Gender]"]:checked'
            ).value;
            const arInput = this.arInput.value;
            if (currentLang == "Spoken Arabic") {
              this.textarea.value = this.dedicationNote(
                currentLang.trim(),
                currentGender.trim(),
                arInput,
                this.arInput.value
              );
            }
          });

          this.arInput.addEventListener("focusout", () => {
            // console.log("f_OUT",this.arInput);
            const currentLang = this.querySelector(
              'input[name="properties[Second Language]"]:checked'
            ).value;
            const currentGender = this.querySelector(
              'input[name="properties[Gender]"]:checked'
            ).value;
            const arInput = this.arInput.value;
            if (currentLang == "Spoken Arabic") {
              this.textarea.value = this.dedicationNote(
                currentLang.trim(),
                currentGender.trim(),
                arInput,
                this.arInput.value
              );
            }
          });
        }

        if (this.enInput) {
          this.enInput.addEventListener("input", () => {
            const currentLang = this.querySelector(
              'input[name="properties[Second Language]"]:checked'
            ).value;
            const currentGender = this.querySelector(
              'input[name="properties[Gender]"]:checked'
            ).value;
            const enInput = this.enInput.value;
            this.textarea.value = this.dedicationNote(
              currentLang.trim(),
              currentGender.trim(),
              enInput,
              this.enInput.value
            );
          });
        }

        // const productForm = document.querySelector(`#${this.form}`);
        // if (productForm) {
        //   const submitButtons = productForm.querySelectorAll("button");
        //   this.enInput.addEventListener("input", () => {
        //     const enPattern = /^[A-Za-z\s\'\"\?\!\(\)]+$/;
        //     //const arabicPattern = /^[؀-ۿ\s\'\"\?\!\-\,\.\;\:\(\)]+$/;
        //     if (enPattern.test(this.enInput.value)) {
        //       //if(arabicPattern.test(this.arInput.value)){
        //       submitButtons.forEach((button) =>
        //         button.removeAttribute("disabled")
        //       );
        //       this.enInput.classList.remove("errorinput");
        //       this.enInput.nextElementSibling.innerHTML = "";
        //       //}
        //     } else {
        //       if (
        //         this.enInput.nextElementSibling &&
        //         this.enInput.value !== ""
        //       ) {
        //         this.enInput.classList.add("errorinput");
        //         this.enInput.nextElementSibling.innerHTML =
        //           "Only English or French names are allowed.";
        //         submitButtons.forEach((button) =>
        //           button.setAttribute("disabled", "disabled")
        //         );
        //       }
        //     }
        //   });

        //   this.enInput.addEventListener("blur", () => {
        //     const currentLang = this.querySelector(
        //       'input[name="properties[Second Language]"]:checked'
        //     ).value;
        //     const currentGender = this.querySelector(
        //       'input[name="properties[Gender]"]:checked'
        //     ).value;
        //     this.textarea.value = this.dedicationNote(
        //       currentLang.trim(),
        //       currentGender.trim(),
        //       this.enInput.value,
        //       ""
        //     );
        //   });
        // }

        const radios = document.getElementsByName(
          "properties[Second Language]"
        );
        radios.forEach((radio) => {
          radio.addEventListener("change", (event) => {
            if (event.target.checked) {
              const enInput = this.enInput.value;
              const currentGender = this.querySelector(
                'input[name="properties[Gender]"]:checked'
              ).value;
              this.textarea.value = this.dedicationNote(
                event.target.value,
                currentGender,
                enInput,
                this.arInput.value
              );
            }
          });
        });

        const arabicPattern = /^[؀-ۿ\s\'\"\?\!\-\,\.\;\:\(\)]+$/;
        const enPattern = /^[A-Za-z\s\'\"\?\!\-\,\.\;\:\(\)]+$/;
        // this.textarea.addEventListener("input", function () {
        //   this.value = this.value
        //     .split("")
        //     .filter((char) => enPattern.test(char) || char === " ")
        //     .join("");
        // });

        this.textarea.value = this.dedicationNote();

        const dataWG =
          document.documentElement.getAttribute("data-wg-translated");
        if (dataWG === "ar") {
          this.translateToArabic();
        }
      }

      translateToArabic() {
        const input = {
          step1header: "الخطوة 1 - أدخل اسم طفلك الصغير",
          secondLanguage: "اختر لغة ثانية",
          secondLanguageOption1: "اللغة العربية المنطوقة",
          secondLanguageOption2: "إنجليزي",
          secondLanguageOption3: "فرنسي",
          secondLanguageHelpText:
            "اللغة الأولى للكتاب هي اللغة العربية الفصحى، يرجى اختيار اللغة الثانية",
          arabicName: "الاسم بالحروف العربية",
          arabicNameHelpText: "تأكد من أن الاسم مكتوب بالحروف العربية",
          latinName: "الاسم بالحروف الإنجليزي/الفرنسي",
          latinNameHelpText: "تأكد من التحقق من الاسم الإنجليزي/الفرنسي",
          step2header: "الخطوة 2 - هل هذا لصبي أم فتاة؟",
          genderLabel: "الجنس",
          genderOption1: "ولد",
          genderOption2: "بنت",
          step3header: "الخطوة 3 - أضف لمساتك النهائية!",
          coverLabel: "حدد الغلاف",
          coverOption1: "غطاء ناعم",
          dedicationLabel: "أضف الإهداء",
          dedicationLabelHelpText:
            "📝 سيظهر الإهداء في رسالة داخل الكتاب (250 حرفًا)",
          htmlElement: "",
        };

        const selector = {
          step1header: 'div[data-element-id="heading-1"] div h3',
          secondLanguage: 'div[data-element-id="radio-1"] label .label-content',
          secondLanguageOption1: 'label[for="radio-1_1"] span',
          secondLanguageOption2: 'label[for="radio-1_2"] span',
          secondLanguageOption3: 'label[for="radio-1_3"] span',
          secondLanguageHelpText:
            'div[data-element-id="radio-1"] .gpo-helptext',
          arabicName: 'div[data-element-id="text-1"] label .label-content',
          arabicNameHelpText: 'div[data-element-id="text-1"] .gpo-helptext',
          latinName: 'div[data-element-id="text-2"] label .label-content',
          latinNameHelpText: 'div[data-element-id="text-2"] .gpo-helptext',
          step2header: 'div[data-element-id="heading-2"] div h3',
          genderLabel: 'div[data-element-id="radio-2"] label .label-content',
          genderOption1: 'label[for="radio-2_1"] span',
          genderOption2: 'label[for="radio-2_2"] span',
          step3header: 'div[data-element-id="heading-3"] div h3',
          coverLabel: 'div[data-element-id="radio-3"] label .label-content',
          coverOption1: 'label[for="radio-3_1"] span',
          dedicationLabel:
            'div[data-element-id="textarea-1"] label .label-content',
          dedicationLabelHelpText:
            'div[data-element-id="textarea-1"] .gpo-helptext',
          htmlElement: 'div[data-element-id="html-1"] div',
        };

        for (const key in selector) {
          if (selector.hasOwnProperty(key)) {
            document.querySelector(selector[key]).textContent = input[key];
          }
        }
      }
    }
  );
}
